// Generates a random string ID using base-36 alphabet chars (0-9 and a-z).
export default function randomString(length = 6) {
  return [...Array(length)].map(() => Math.random().toString(36)[2]).join('');
}
